import { actionTypes } from "../actionTypes/actionTypes";
import { AcronymReducerState } from "../../interfaces/store/acronymReducerState";
import { ADMIN } from "../../constants/admin";

const initialState: AcronymReducerState = {
  id: null,
  acronymFormOpen: false,
  acronymTableData: [],
  acronymFormType: ADMIN.MEETING_FORM_TYPE.CREATE,
  acronymSelectedRowData: null,
  fetchAcronym: false,
};

const acronymReducer = (
  state: AcronymReducerState = initialState,
  action: any
) => {
  switch (action.type) {
    case actionTypes.OPEN_ACRONYM_FORM:
      return {
        ...state,
        acronymFormOpen: action.payload,
      };
    case actionTypes.UPDATE_ACRONYM_TABLE_DATA:
      return {
        ...state,
        acronymTableData: action.payload,
      };
    case actionTypes.SELECTED_ACRONYM_TABLE_ROW:
      return {
        ...state,
        acronymSelectedRowData: action.payload,
      };
    case actionTypes.UPDATE_ACRONYM_FORM_TYPE:
      return {
        ...state,
        acronymFormType: action.payload,
      };
    case actionTypes.UPDATE_FETCH_ACRONYM:
      return {
        ...state,
        fetchAcronym: action.payload,
      };

    default:
      return state;
  }
};

export default acronymReducer;

